<template>
  <div class="about">
    <div class="about-wrapper">
      <h1 class="aboutUs-title">关于我们</h1>
      <p class="titleInfo">About Us</p>
      <p class="s1">
        vTrack 凝聚了进出口贸易实务、渠道营销、品牌运营、市场策划、物流管理。
        解决产品从工厂到国内B端采购商户的整体供应链路。核心成员在各个板块服务超过15年，致力为每个贸易人连接更多商机，为迷茫的同伴开拓更宽广的市场。
      </p>
      <p class="s1">
        vTrack integrating practical experience in import and export trade, channel
        marketing, brand operation, market planning, and logistics management. Solve the
        overall supply chain of products from the factory to domestic B-end purchasing
        merchants. The core members have served in various sectors for over 15 years,
        dedicated to connecting more business opportunities for every trader and opening
        up broader markets for confused partners.
      </p>
      <p class="s1">客服热线 : 18820037803</p>
      <p class="s1">Customer Service hotline : 18820037803</p>
      <div class="noticeBox" v-if="isApp">
        <div class="noticeVersion">{{ $t.aboutUs.currentVersion }} {{ appVersion }}</div>
        <!-- <div class="noticeButton" @click="onDownload">
        {{ $t.aboutUs.updateVersion }}
      </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { isAPP, getPlatform } from "@/plugins/environment/type.js";
import { getVersionNumber } from "@/plugins/environment/model/appVersion";

export default {
  name: "AboutUs",
  data() {
    return {
      isApp: isAPP(),
      platform: getPlatform(),
      appVersion: "1.0.0",
    };
  },
  created() {
    if (this.isApp) {
      getVersionNumber().then((version) => {
        this.appVersion = version;
      });
    }
  },
  methods: {
    onDownload() {
      var url = "";
      if (this.platform == "android") {
        url = "https://a.app.qq.com/o/simple.jsp?pkgname=com.vtrack.app";
      }
      if (this.platform == "ios") {
        url = "https://apps.apple.com/app/vtrack/id6745947971";
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.gotoPay, {
        url: url,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.about {
  width: 100%;
  display: inline-block;
  * {
    font-size: 11px;
  }
  .about-wrapper {
    width: 90%;
    margin: auto;
    padding-top: 15px;
    padding-bottom: calc(15px + env(safe-area-inset-bottom));
    .aboutUs-title {
      width: 100%;
      text-align: center;
      font-size: 13px;
    }
    .titleInfo {
      width: 100%;
      text-align: center;
      margin: 10px 0;
    }
    .info {
      width: 100%;
      text-align: center;
      margin: 25px 0;
    }
    .s1 {
      text-align: left;
      margin: 25px 0;
    }
    .sTitle {
      text-align: left;
      margin: 25px 0;
    }
  }
  .noticeBox {
    width: 90%;
    color: #999;
    text-align: center;
    position: fixed;
    bottom: 0;
    padding-top: 5%;
    margin-bottom: 10%;
    border-top: 1px solid #e5e5e5;
    .noticeVersion {
      margin-bottom: 5%;
    }
    .noticeButton {
      width: 80%;
      margin: auto;
      border-radius: 3rem;
      padding: 0.8rem 0;
      text-align: center;
      background: linear-gradient(left, #009ed4, #5029c3);
      color: #ffffff;
      font-size: 1rem;
      line-height: 1;
    }
  }
}
</style>
